import { MasterDialog } from "#common/Dialog/Dialog"
import InputAutocompleteGroup from "#core/components/input/autocomplete/InputAutocompleteGroup"
import { useApi } from "#hooks/useApi"
import { useApiSend } from "#hooks/useApiSend"
import { jobProfileToolsPost, toolsGet } from "#job-profile/services/api"
import { Button } from "@mui/material"
import Box from "@mui/material/Box"
import { useCallback, useMemo, useState } from "react"
import { JobProfileToolsTable } from "./JobProfileToolsTable"

export const JobProfileToolsFormList = ({ value, setValue }) => {
	const [tool, setTool] = useState("")
	const handleSave = () => {
		if (!tool) return
		setValue((old) => [...old, tool])
		setTool(null)
	}

	return (
		<Box display={"flex"} flexDirection={"column"} gap={2} alignItems={"center"}>
			<InputAutocompleteTools excluded={value} value={tool} setValue={setTool} />
			<Button onClick={handleSave}>Agregar</Button>
			<JobProfileToolsTable data={value} />
		</Box>
	)
}

export const JobProfileToolsFormDialog = ({
	open,
	setOpen,
	profileId,
	refresh,
	excluded = [],
}) => {
	const [tool, setTool] = useState(null)
	const [disabled, setDisabled] = useState(false)

	const success = () => {
		setOpen(false)
		setTool(null)
		refresh()
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(jobProfileToolsPost, { success, end })

	const handleSend = useCallback(() => {
		if (!tool) return

		setDisabled(true)
		fetch(profileId, { herramientas_trabajo: tool })
	}, [fetch, profileId, tool])

	const handleClose = useCallback(() => {
		setOpen(false)
		setTool("")
	}, [setOpen])

	const buttons = useMemo(
		() => [
			{
				label: "Cancelar",
				onClick: handleClose,
				disabled,
			},
			{
				label: "Agregar",
				onClick: handleSend,
				disabled,
			},
		],
		[disabled, handleClose, handleSend]
	)

	return (
		<MasterDialog
			{...{
				open,
				setOpen,
				title: "Agregar Herramienta",
				buttons,
				maxWidth: "md",
			}}
		>
			<InputAutocompleteTools
				excluded={excluded}
				value={tool}
				setValue={setTool}
				optionsId={"id"}
			/>
		</MasterDialog>
	)
}

export function InputAutocompleteTools({
	value,
	setValue,
	excluded,
	optionsId,
	autoFetch = true,
}) {
	const params = useMemo(() => ({ list: true }), [])
	const { data, loading } = useApi(toolsGet, { autoFetch, params })

	const herramientas = useMemo(() => data?.data || [], [data])

	const toolsFree = useMemo(
		() => herramientas.filter((herramienta) => !excluded.includes(herramienta.id)),
		[excluded, herramientas]
	)

	return (
		<InputAutocompleteGroup
			value={value}
			setValue={(newValue) => setValue(newValue)}
			options={toolsFree}
			loading={loading}
			groupBy={"departamento_name"}
			optionsLabel="description"
			optionsId={optionsId}
		/>
	)
}
